<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-menu title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-s-grid"></i>
        <span>分类列表</span>
        <div class="header-actions">
          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.mall_goods_cate_add)"
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="goAddOrEdit(null)"
            class="add-btn"
            >新增</el-button
          >
        </div>
      </div>

      <el-table
        :data="list"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :header-row-style="{ height: '50px', color: '#626e7c' }"
        :header-cell-style="{ background: '#f8f9fb', padding: '8px 0' }"
        :cell-style="changeTr"
        :indent="30"
        class="category-table"
      >
        <el-table-column label="分类" align="left" min-width="250px">
          <template slot-scope="scope">
            <div class="category-cell">
              <span class="category-id">{{ scope.row.id }}</span>
              <span class="category-name">{{ scope.row.categoryName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" min-width="120px">
          <template slot-scope="{ row }" v-if="!row.children">
            <el-switch
              :disabled="!isShowBtn(AUTH_BTN.mall_goods_cate_status)"
              class="switch"
              @change="changeStatus(row)"
              v-model="row['status']"
              :active-value="true"
              :inactive-value="false"
              active-text="显示"
              inactive-text="隐藏"
            ></el-switch>
          </template>
          <template v-else>
            <span class="table-cell-text">-</span>
          </template>
        </el-table-column>
        <el-table-column label="图标" align="center" min-width="120px">
          <template slot-scope="scope">
            <el-image 
              v-if="scope.row.iconUrl"
              class="category-icon" 
              :src="scope.row.iconUrl"
              :preview-src-list="[scope.row.iconUrl]"
              fit="cover"
            />
            <span v-else class="table-cell-text">-</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" align="center" min-width="100px">
          <template slot-scope="scope">
            <el-tag size="mini" type="info">{{ scope.row.sort || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180px">
          <template slot-scope="scope">
            <div class="action-links">
              <el-link
                v-checkbtn="isShowBtn(AUTH_BTN.mall_goods_cate_edit)"
                :disabled="scope.row.status"
                :underline="false"
                type="primary"
                @click="goAddOrEdit(scope.row)"
                class="action-link"
              >
                编辑
              </el-link>

              <el-link
                v-checkbtn="isShowBtn(AUTH_BTN.mall_goods_cate_del)"
                :disabled="scope.row.status"
                :underline="false"
                type="danger"
                @click="delCategory(scope.row.id)"
                class="action-link"
              >
                删除
              </el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增&编辑 -->
    <AddOrEdit
        v-if="showAddOrEdit"
        :rowId="rowId"
        :showAddOrEdit="showAddOrEdit"
        @closeDialog="closeDialogFun"
    />
  </div>
</template>

<script>
import { getGoodsCategoryTreeAPI, deleteGoodsCategoryAPI, changeStatusAPI } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import AddOrEdit from "./add-edit.vue";

export default {
  name: 'MallGoodsCategory',
  components: {AddOrEdit},
  mixins: [authBtnMixin],
  data() {
    return {
      list: [],
      rowId: null,
      parentRowId: null,
      showAddOrEdit: false,
    }
  },
  computed: {
    total() {
      const countNodes = (nodes) => {
        let count = 0;
        if (nodes && nodes.length > 0) {
          nodes.forEach(node => {
            count++;
            if (node.children && node.children.length > 0) {
              count += countNodes(node.children);
            }
          });
        }
        return count;
      };
      return countNodes(this.list);
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {
    this.getGoodsCategoryTree();
  },
  methods: {
    // 新增子菜单
    goAddOrEdit(row) {
      if (row) {
        const { id, parentId } = row;
        this.showAddOrEdit = true;
        this.rowId = id;
        this.parentRowId = parentId;
      } else {
        this.showAddOrEdit = true;
        this.rowId = null;
        this.parentRowId = null;
      }
    },
    async getGoodsCategoryTree() {
      let res = await getGoodsCategoryTreeAPI();
      this.list = res || [];
    },
    async delCategory(id) {
      this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteGoodsCategoryAPI(id).then(() => {
            this.getGoodsCategoryTree()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 修改第一列无children的样式
    changeTr({ row, column, rowIndex, columnIndex }) {
      if (!row.children && columnIndex == 0) {
        return { paddingLeft: '23px' }
      }
    },
    changeStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let desc = status ? '显示' : '隐藏';

      this.$confirm(`此操作将该分类${desc}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.status = status;
          changeStatusAPI(data).then(() => {
            this.getGoodsCategoryTree();
            this.$message.success('操作成功');
          })
        })
        .catch(() => {
          row.status = !status;
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        })
    },
    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      if (flag) {
        this.getGoodsCategoryTree();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 28px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-stats {
    display: flex;
    gap: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 8px 16px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 10px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 4px;
      }
      
      .stat-value {
        font-size: 20px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
  
  .header-actions {
    display: flex;
    gap: 12px;
    margin-left: auto;
    
    .add-btn {
      border-radius: 10px;
      padding: 9px 20px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      
      &:hover:not(.is-disabled) {
        transform: translateY(-2px);
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
      }
      
      &.is-disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }
  
  .category-table {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #EBEEF5;
    
    ::v-deep .el-table__header-wrapper {
      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }
    }
    
    ::v-deep .el-table__body-wrapper {
      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
            
            .category-cell {
              display: flex;
              align-items: center;
              gap: 12px;
              
              .category-id {
                color: #909399;
                font-size: 12px;
                font-weight: 500;
                padding: 2px 8px;
                background: #f0f2f5;
                border-radius: 4px;
              }
              
              .category-name {
                color: #303133;
                font-size: 14px;
                font-weight: 500;
              }
            }
            
            .category-icon {
              width: 60px;
              height: 60px;
              border-radius: 8px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
              transition: all 0.3s ease;
              cursor: pointer;
              
              &:hover {
                transform: scale(1.05);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
              }
            }
            
            .table-cell-text {
              color: #909399;
              font-size: 13px;
            }
            
            .action-links {
              display: flex;
              flex-wrap: wrap;
              gap: 8px;
              justify-content: center;
              
              .action-link {
                font-weight: 500;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                
                &:hover:not(.is-disabled) {
                  transform: translateY(-1px);
                }
                
                &.is-disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }
    }
  }
}

// switch按钮样式
::v-deep .switch {
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  .el-switch__label--right {
    z-index: 1;
  }

  .el-switch__label--right span {
    margin-right: 10px;
  }

  .el-switch__label--left {
    z-index: 1;
  }

  .el-switch__label--left span {
    margin-left: 20px;
  }

  .el-switch__label.is-active {
    display: block;
  }

  .el-switch__core,
  .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    .header-stats {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .card-header-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .header-actions {
      width: 100%;
      flex-wrap: wrap;
    }
  }
}
</style>
